import { pickBy, identity } from 'lodash';
import queryString from 'query-string';

export const skipEmptyStrings = (query) =>
  Object.keys(query)
    .filter((k) => query[k] !== '')
    .reduce((a, k) => ({ ...a, [k]: query[k] }), {});

export const addQueryParams = ({ history, location }, newParams) => {
  const currentParams = queryString.parse(location?.search);
  const mergedParams = { ...currentParams, ...newParams };
  history.push({
    search: queryString.stringify(pickBy(mergedParams, identity)),
    pathname: window.location.pathname,
  });
};
